import { render, staticRenderFns } from "./ReviewDashboard.vue?vue&type=template&id=0df4b456&"
import script from "./ReviewDashboard.vue?vue&type=script&lang=js&"
export * from "./ReviewDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports